import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'delivery-accelerators-tab-2-part',
	standalone: true,
	templateUrl: './delivery-accelerators-tab-2.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./delivery-accelerators-tab-2.part.scss`],
})
export class DeliveryAcceleratorsTab2Part {
}
